export enum AUTHORIZATION_STATUS {
  /**
   * Authorization has no known status.
   * This shouldn't really be used by an Authorization itself.
   */
  NONE = 'N',
  /**
   *
   */
  INITIATED_CASE_MEDICAL = 'IM',
  INITIATED_CASE_INSURANCE = 'II',
  /**
   * Payer needs more information.
   */
  CONTACT_PAYER = 'CP',
  /**
   * Prior authorization has been denied.
   * Also known as "A3 Not Certified"
   */
  DENIED = 'D',
  INELIGIBLE = 'I',
  /**
   * When an authorization is denied, it can sometimes be submitted for peer review
   * This can ask for one-time exceptions typically not covered by the patient's insurance
   * Review is based on medical necessity.
   */
  PEER_REVIEW = 'PR',
  /**
   * Prior authorization has been approved (aka Certified).
   */
  APPROVED = 'A',
  /**
   * Prior Authorization was created via HL7, we don't want to assume it was
   * Approved until it is verified.
   */
  CREATED_BY_INTEGRATION = 'C',
  /**
   * Prior authorization has been partially approved.
   */
  PARTIALLY_APPROVED = 'A2',
  /**
   * A prior auth was submitted but is not required for this procedure by the payer.
   * Generally this means we can look to add a new Authorization Required rule.
   *
   * Status is typically not set by a user.
   */
  NO_ACTION_REQUIRED = 'NAR',
  /**
   * Prior authorization is no longer necessary, patient may have cancelled their appointment.
   */
  CANCELLED = 'CA',
  /**
   * Prior authorization has
   */
  COMPLETED = 'CO',
  /**
   * Prior authorization has expired.
   */
  EXPIRED = 'E',
}
